import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { Players } from "../../types/playersTypes";
import { RootState } from "../store";

const initialState: Players = {
  playerList: [],
};

export const clearPlayersStateAsync = createAsyncThunk(
  "players/clearPlayersState",
  async () => {
    // Clear players state logic if needed
  },
);

export const playerSlice = createSlice({
  name: "players",
  initialState,
  reducers: {
    storePlayers: (state, action) => {
      state.playerList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearPlayersStateAsync.fulfilled, (state) => {
      state.playerList = initialState.playerList;
    });
  },
});

export const selectPlayers = (state: RootState): Players => state.players;
